import { ChangeDetectionStrategy, Component, Input, OnInit, input } from '@angular/core';
import { Notification } from '../../core/services/dataservice.svc';

import { AccordionModule } from 'primeng/accordion';
import { SkeletonModule } from 'primeng/skeleton';
import { DatePipe } from '@angular/common';
import { DialogModule } from 'primeng/dialog';

@Component({
    selector: 'whats-new-modal',
    templateUrl: './whats-new-modal.component.html',
    styleUrls: ['./whats-new-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DialogModule, SkeletonModule, AccordionModule, DatePipe]
})
export class WhatsNewModalComponent implements OnInit {

    private _notifications: Notification[];

    readonly loading = input<boolean>(undefined);
    @Input() visible: boolean;
    // TODO: Skipped for migration because:
    //  Accessor inputs cannot be migrated as they are too complex.
    @Input() set notifications(value: Notification[]) {
        this._notifications = value;
        this.isVisible = this.notifications?.length > 0 || this.notifications != undefined;
    }

    get notifications(): Notification[] {
        return this._notifications;
    }

    public isVisible: boolean = false;

    constructor() {
    }

    ngOnInit(): void {
    }
}
